require("utility/alt_modal.scss");

class AltModal extends React.Component {

	constructor(props) {
		super();
		autobind(this);

		if (props.open !== undefined) {
			var open = props.open;
		} else {
			var open = false;
		}
		this.state = { open: open, modalIn: false };
	}

	show() {
		this.setState({ open: true }, () => {
			$("body").addClass("modal-open");

			// Slightly delay showing the modal as "in" so the CSS transitions work
			setTimeout(() => {
				this.setState({ modalIn: true });
			}, 40);

			if (this.props.onShow) {
				this.props.onShow()
			}

		});
		this.activateScrollListener();
	}

	hide() {
		if (this.props.preventHide) {
			if (this.props.onHidePrevented) {
				this.props.onHidePrevented();
			}
			return;
		}
		this.setState({ modalIn: false }, () => {
			setTimeout(() => {
				this.setState({ open: false }, () => {
					this.removeBodyModalOpen();
				});

				if (this.props.onHide) {
					this.props.onHide();
				}
			}, 200); // 200 is slightly more than the .15s on the modal transitions
		});
		this.dectivateScrollListener();
	}

	removeBodyModalOpen() {
		// Only remove this class if we're the last modal off the page
		var openModalCount = $(".modal.in").length;
		if (openModalCount == 0) {
			$("body").removeClass("modal-open");
		}
	}

	onOutsideClick(e) {
		// Only if we clicked outside the children of the modal (e.g. the actual modal)
		if (e.target == this.refs.modal) {
			this.hide();
		}
	}

	render() {
		if (!this.state.open) {
			return (
				<div className="modalWrap" />
			);
		}

		if (this.props.studentProgressEmail) {
			var modalHeader = (
				<div className="modal-header">
					<h2 className="modal-title">Student Progress <br/></h2>
					<p className="datesSubHeader">{ this.props.headerText }</p>	
				</div>
			);
		} else if (this.props.headerText) {
			var modalHeader = (
				<div className="modal-header">
					<h2 className="modal-title">
						{ this.props.headerText }
					</h2>
				</div>
			);
		} else if (this.props.headerContent) {
			var modalHeader = (
				<div className="modal-header">
					<h2 className="modal-title">
						{ this.props.headerContent }
					</h2>
				</div>
			);
		}

		var modelClass = "altModal modal fade";
		var backdropClass = "modal-backdrop fade";

		if (this.state.modalIn) {
			modelClass += " in";
			backdropClass += " in";
		}

		if (this.props.className) {
			modelClass += " " + this.props.className;
		}

		var backdropZIndex = 999999;
		if (this.props.modalOrder) {
			backdropZIndex += 100 * this.props.modalOrder;
		}

		var modalZIndex = backdropZIndex + 1;

		if (this.props.actionButtons) {
			var modalFooter = (
				<div className="modal-footer">
					{ this.props.actionButtons }
				</div>
			)
		}

		return (
			<div className="modalWrap">
				<div className={ modelClass } role="dialog" style={{ zIndex: modalZIndex }}
					onClick={ this.onOutsideClick } ref="modal">
					<div className="modal-dialog" role="document">
						<div className="modal-content">
							{ modalHeader }
							<div className="modal-body">
								{ this.props.children }
							</div>
							{ modalFooter }
						</div>
					</div>
				</div>
				<div className={ backdropClass } style={{ zIndex: backdropZIndex }} />
			</div>
		);
	}

	listenKeyboardExit(e) {
		if (this.state.modalIn && (e.key == "Escape" || e.keyCode == 27)) {
			this.hide();
		}
	}

	componentDidMount(){
		window.addEventListener("keydown", this.listenKeyboardExit, true);

		if (this.props.selfOpen) {
			this.show();
		}
		this.activateScrollListener();
	}

	componentWillUnmount() {
		window.removeEventListener("keydown", this.listenKeyboardExit, true);
		setTimeout(this.removeBodyModalOpen, 200);
		this.dectivateScrollListener();

	}

	activateScrollListener() {
		this.dectivateScrollListener(); // In case it's already been activated

		// Apparently we need to wait a few ticks for the modal to get instantiated
		// Not sure why?
		setTimeout(() => {
			$(this.refs.modal).on("scroll", this.globalScrollEvent);
		}, 20)

	}
	dectivateScrollListener() {
		$(this.refs.modal).off("scroll", this.globalScrollEvent);
	}
	globalScrollEvent() {
		$(document).trigger("modal-scroll");
	}

	componentDidUpdate(prevProps) {
		if (prevProps.open !== this.props.open) {
			if (this.props.open) {
				this.show();
			} else {
				this.hide();
			}
		}
	}

};

AltModal.propTypes = StrictPropTypes({
	// Components to render inside the modal
	children: PropTypes.oneOfType([
		PropTypes.object,
		PropTypes.array
	]),

	// Controls if the modal is open or closed
	// OPTIONAL, if null, modal must be controlled by refs
	open: PropTypes.bool,

	// Text to display across the top of the modal
	headerText: PropTypes.string,
	headerContent: PropTypes.object,

	// Class to add to the modal
	className: PropTypes.string,

	// CSS ID
	id: PropTypes.string,

	// Indicates if its progress email modal
	studentProgressEmail: PropTypes.bool,

	// If true, modal automatically opens on mount
	selfOpen: PropTypes.bool,

	// If true, prevents the user from clicking out of the modal
	preventHide: PropTypes.bool,
	// Function to call after the modal has been prevented from being hidden
	onHidePrevented: PropTypes.func,
	
	// Function to call after the modal is hidden
	onHide: PropTypes.func,

	// Function to call after the modal is shown
	onShow: PropTypes.func,

	// Stacking order of this modal relative to others (default is 1),
	modalOrder: PropTypes.number,

	// Buttons container
	actionButtons: PropTypes.object,

	onModalHidden: PropTypes.func,

});


module.exports = AltModal;



// WEBPACK FOOTER //
// ./modules/components/utility/AltModal.js